export function useUseTerm() {
  return {};
}
